import { Phone } from "./Phone";
import { Reveal, SectionHead } from "./Reveal";

const screens = [
  { src: "/img/post.png", alt: "Post a catch screen", title: "Post a catch", text: "Snap your fish, pick from 61 species, add length, weight and state." },
  { src: "/img/shop.png", alt: "Daily shop screen", title: "Daily shop", text: "Spend gems on profile borders — bronze to unique — refreshed daily." },
];

export const Screens = () => (
  <section id="inside" className="relative overflow-hidden py-24 sm:py-36">
    <div className="pointer-events-none absolute left-1/2 top-1/3 h-[480px] w-[480px] -translate-x-1/2 rounded-full bg-[#00E5FF]/10 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead over="// Inside the app" title={<>Real screens.<br /><span className="text-outline">Real catches.</span></>} />
      <div className="grid grid-cols-1 md:grid-cols-2 max-w-3xl mx-auto gap-14 md:gap-8 items-start">
        {screens.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.12} className={i === 1 ? "md:mt-16" : ""}>
            <Phone src={s.src} alt={s.alt} testid={`screen-${i}`} className="mx-auto w-full max-w-[280px] hover:-translate-y-2 transition-transform duration-500" />
            <div className="mx-auto mt-6 max-w-[280px]">
              <p className="font-mono text-xs text-[#F59E0B]">0{i + 1}</p>
              <h3 className="mt-1 font-display text-2xl font-extrabold uppercase text-white">{s.title}</h3>
              <p className="mt-1 text-sm text-slate-300">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
